import { compose, filter, groupBy, map, size } from 'lodash/fp';
import type AdminLink from '../../../../../types/AdminLink';
import { isFeatureEnabled } from '../../../services/Features';
import replacement, { type ReplacementKey } from '../../../services/Replacement';

const applyReplacement = (link: AdminLink) => {
    if (link.nameType === 'REPLACEMENT') {
        return {
            ...link,
            name: replacement(link.name as ReplacementKey),
        };
    }
    return link;
};

const isFeatureEnabledForLink = (link: AdminLink) => {
    if (link.name === 'Glossary') {
        return isFeatureEnabled('FEATURE_glossary');
    }
    return true;
};

export const groupLinksByCategory = (links: AdminLink[]) =>
    compose(
        groupBy('category'),
        map(applyReplacement),
        filter((link: AdminLink) => link.visible && isFeatureEnabledForLink(link))
    )(links);

export const countAdminErrors = (links: AdminLink[]) =>
    compose(
        size,
        filter((link: AdminLink) => link.status === 'ERROR')
    )(links);
